import * as CONNECTION from './Connection';

export const RESOURCE_SECTION_LABEL = {
  GENERAL_INFORMATION: 'GENERAL INFORMATION',
  NZFAP_PLUS: 'NZFAP PLUS REQUIREMENTS',
};

export const RESOURCE_SECTION_DAM_PATH = {
  GENERAL_INFORMATION: CONNECTION.GENERALINFORMATIONDOCUMENTSPATH,
  NZFAP_PLUS: CONNECTION.NZFAPDOCUMENTSPATH,
};

export const RESOURCE_TELEMETRY_PROPERTIES = {
  RESOURCE_SECTION: 'ResourceSection',
  RESOURCE_DOCUMENT_ID: 'ResourceDocumentId',
  RESOURCE_DOCUMENT_NAME: 'ResourceDocumentName',
};
